<h2 mat-dialog-title>{{ "HTL.HIL.newExpiringHil" | translate }}</h2>
<div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-left: 26px; margin-top: -20px">
    <div style="margin-right: 10px; font-size: medium">Aircraft Current Total Hours: {{ totalHours || 0 }}</div>
    @if (showFlightNumber) {
        <div style="margin-right: 10px; font-size: medium">Last Flight Number: {{ helicopterData?.flightNumber || 0 }}</div>
    }
    <div style="font-size: medium">Aircraft Current Total Cycles: {{ totalCycles || 0 }}</div>
</div>
<mat-dialog-content class="mat-typography">
    <form #hilExpiringForm="ngForm" fxFlex="100" (ngSubmit)="onFormSubmit()" [formGroup]="hilExpiringFormGroup">
        <app-form-group-title [title]="'HTL.HIL.firstExtension' | translate"></app-form-group-title>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.document" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.document' | translate" name="exe1Document" formControlName="exe1Document" />
                @if (hilExpiringFormGroup.controls["exe1Document"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.date" | translate }}</mat-label>
                <input matInput [matDatepicker]="exe1DatePicker" [placeholder]="'HTL.HIL.date' | translate" name="exe1Date" formControlName="exe1Date" readonly />
                <mat-datepicker-toggle matSuffix [for]="exe1DatePicker"></mat-datepicker-toggle>
                <mat-datepicker #exe1DatePicker></mat-datepicker>
                @if (hilExpiringFormGroup.controls["exe1Date"].hasError("matDatepickerParse")) {
                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                }
                @if (hilExpiringFormGroup.controls["exe1Date"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.flightHours" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.flightHours' | translate" name="exe1FlightHours" formControlName="exe1FlightHours" />
                @if (hilExpiringFormGroup.controls["exe1FlightHours"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.flightNumber" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.flightNumber' | translate" name="exe1FlightNumber" formControlName="exe1FlightNumber" />
                @if (hilExpiringFormGroup.controls["exe1FlightNumber"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.cycles" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.cycles' | translate" name="exe1Cycles" formControlName="exe1Cycles" />
                @if (hilExpiringFormGroup.controls["exe1Cycles"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
        <!--  -->
        <app-form-group-title [title]="'HTL.HIL.secondExtension' | translate"></app-form-group-title>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.document" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.document' | translate" name="exe2Document" formControlName="exe2Document" />
                @if (hilExpiringFormGroup.controls["exe2Document"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.date" | translate }}</mat-label>
                <input matInput [matDatepicker]="exe2DatePicker" [placeholder]="'HTL.HIL.date' | translate" name="exe2Date" formControlName="exe2Date" readonly />
                <mat-datepicker-toggle matSuffix [for]="exe2DatePicker"></mat-datepicker-toggle>
                <mat-datepicker #exe2DatePicker></mat-datepicker>
                @if (hilExpiringFormGroup.controls["exe2Date"].hasError("matDatepickerParse")) {
                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                }
                @if (hilExpiringFormGroup.controls["exe2Date"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.flightHours" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.flightHours' | translate" name="exe2FlightHours" formControlName="exe2FlightHours" />
                @if (hilExpiringFormGroup.controls["exe2FlightHours"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.flightNumber" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.flightNumber' | translate" name="exe2FlightNumber" formControlName="exe2FlightNumber" />
                @if (hilExpiringFormGroup.controls["exe2FlightNumber"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.cycles" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.cycles' | translate" name="exe2Cycles" formControlName="exe2Cycles" />
                @if (hilExpiringFormGroup.controls["exe2Cycles"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
        {{ "GENERAL.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="hilExpiringForm.ngSubmit.emit()">
        {{ "GENERAL.save" | translate }}
    </button>
</mat-dialog-actions>
